import React from "react";
import { inject, observer } from "mobx-react";
import gameActionOptions from "../constants/gameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class HighAGameActionDropDownContainer extends React.Component {
  render() {
    const { HighAGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={gameActionOptions}
        transitionToCreateIncident={
          HighAGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={HighAGameActionStore.clearClippyCache}
        clearStatsApiCache={HighAGameActionStore.clearStatsApiCache}
        resendGame={HighAGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(observer(HighAGameActionDropDownContainer));
